import type { JWTDecoded } from '@kinde/jwt-decoder'
import { jwtDecoder } from '@kinde/jwt-decoder'

export type UserJWTDecoded = JWTDecoded & {
  user_properties?: { salesforce_id?: { v?: string }; zephr_id?: { v?: string } }
}

export const decodeToUserJWT = (token: string) => jwtDecoder(token) as UserJWTDecoded
